import { takeLatest, call } from 'redux-saga/effects'
import * as ACTIONS from 'constants/Actions'
import { sendContactData } from 'api/contact'
import { toastr } from 'react-redux-toastr'

export function* saveContactDataWatcherSaga() {
    yield takeLatest(ACTIONS.SEND_CONTACT_INFO, saveContactDataWorkerSaga)
}

export function* saveContactDataWorkerSaga({data}) {
    try {
        let response = yield call(sendContactData, data)

        if (response.status === 200) {
            toastr.success('Success: Your message has been sent. Thank you for reaching out.')
        }
    }
    catch(error) {
        toastr.error('Error: ' + error)
    }
}